import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MinimapService } from '../../services/minimap.service';
import { UnitTransmissionStatusService } from 'src/app/units/services/unit-transmission-status.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { convertSecondsToTimeString } from 'src/app/vehicles/components/content-panel-vehicles/helpers/convert-seconds-to-time-string';

@Component({
  selector: 'app-maps-slider',
  templateUrl: './maps-slider.component.html',
  styleUrls: ['./maps-slider.component.scss']
})
export class MapsSliderComponent implements OnInit {
  @Output() onClose = new EventEmitter<boolean>();

  
  maps: any[] = [];             // Lista que se renderiza (filtrada)
  originalMaps: any[] = [];     // Lista completa, sin filtrar
  searchTerm: string = '';

  private searchTermChanged = new Subject<string>();

  constructor(
    private minimaService : MinimapService,
    private unitTransmission : UnitTransmissionStatusService
  ) { }

  ngOnInit(): void {
    this.minimaService.maps$.subscribe((newMaps) => {
      // Actualiza solo lo necesario
      newMaps.forEach((newMap) => {
        const existingMap = this.originalMaps?.find(
          (oldMap) => oldMap.minimapConf?.title === newMap.minimapConf?.title
        );

        if (existingMap) {
          // Solo actualiza los datos cambiados (sin reemplazar la referencia)
          Object.assign(existingMap, newMap);
        } else {
          // Si no existe, lo añadimos
          this.originalMaps.push({
            ...newMap,
            isOpen: true,
          });
        }
      });

      // Elimina los mapas que ya no están
      this.originalMaps = this.originalMaps.filter((oldMap) =>
        newMaps.some((newMap) => newMap.minimapConf?.title === oldMap.minimapConf?.title)
      );

      this.applyFilter();
    });

     // Escuchar cambios con debounce
    this.searchTermChanged
      .pipe(debounceTime(400)) // espera 400ms sin escribir
      .subscribe((term) => {
        this.searchTerm = term;
        this.applyFilter();
      });

  }

  trackByMap(index: number, map: any): string {
    return map.minimapConf?.title;
  }

  trackByVehicle(index: number, vehicle: any): string {
    return vehicle.unit?.device?.IMEI ?? index;
  }

  onSearchChange(value: string): void {
    this.searchTermChanged.next(value);
  }
  applyFilter(): void {
    const term = this.searchTerm.trim().toLowerCase();

    if (!term) {
      this.maps = [...this.originalMaps];
      return;
    }

    let mapFiltered = this.originalMaps
      .map(map => {
        const titleMatch = map.minimapConf.title?.toLowerCase().includes(term);
        const filteredVehicles = (map.minimapConf.vehicles || []).filter((vehicle : any) => {
          const imei = vehicle?.unit?.device?.IMEI?.toLowerCase() || '';
          const name = vehicle?.unit?.unitName?.toLowerCase() || '';
          return imei.includes(term) || name.includes(term);
        });

        if (titleMatch) return { ...map };
        if (filteredVehicles.length > 0) {
          return {
            ...map,
            minimapConf: {
              ...map.minimapConf,
              vehicles: filteredVehicles
            }
          };
        }

        return null;
      })
      .filter(Boolean);

    this.maps = mapFiltered;
  }

  convertSecondsToTimeString(seconds: number): string {
    return convertSecondsToTimeString(seconds, {
      shortFormat: true,
      showZeros: false,
    });
  }

  public getTransmissionInfo(id : string) {
    return this.unitTransmission.getTransmissionInfoById(id)
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copiado:', text);
    });
  }

  toggleSlider() {
    this.onClose.emit(true)
  }

  // event maps slider
  clickCard(map : any, vehicle : any) {
    this.minimaService.focusMap(map._containerId, [vehicle])
  }
  clickGroup(map : any) {
    this.minimaService.focusMap(map._containerId)
  }
}
